const replacePermissionRouteWildcards = permissionRoute => permissionRoute.replace(/\*/g, ':rest*');

module.exports = replacePermissionRouteWildcards;
